module.exports = __webpack_public_path__ + "img/echo-viewpoint-2.e3510c1e.jpg";